import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { PatientService, User, UserService } from '../../shared';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  templateUrl: 'addcare.component.html',
  styleUrls: ['./style.component.css']
})

export class AddcareComponent implements OnInit {
  public timealert = environment.timelimit;
  public data: Object;
  setmask: any;
  setmask1: any;
  ffar: string = '';
  dateformat: any;
  public Patpro: any = {
    gender: "",
    onBehalf: false,
    code: '+1' + ',' + 'USA',
    relationship: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
  };
  mobile_val: any;
  codes: any;
  alterNo: any;
  getEmaildata: any;
  public addcarepost: Object;
  hospitalid: any;
  patientdetail: any;
  alertShowed: any;
  imgMaxSize: any = environment.imagefileSize;
  showloader: boolean = false;
  defaultimg: boolean = true;
  btnshow: boolean = true;
  btnshow1: boolean = false;
  defaultmyimg: boolean = false;
  caredataimg: any;
  terms: number = 0;
  careimagearr;
  resdata: any;
  maxlen: any;
  setlength: any;
  maxlen1: any;
  setlength1: any;
  CurrentUser: User;
  apiurl: any = environment.api_url;
  imageURL: any;
  public bsConfig: Partial<BsDatepickerConfig> = null;
  modalRef: BsModalRef;
  prefLang: string = '';
  languageConfig = {
		"multiLanguageRequired" : false,
		"languages": []
	};
  languageSubscription: Subscription;
  
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userservice: UserService,
    private modalService: BsModalService,
    private patientservice: PatientService,
    private toast: ToastrService,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang(userservice.defaultLang); 
    this.prefLang = this.userservice.LoginDefaultLanguage;
   };

  ngOnInit() {
    this.userservice.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');
          this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0');
          if (this.CurrentUser.item.language != 'en_uk') {
            this.Patpro.code = '+1,USA'
            this.Patpro.codeOther = '+1,USA'
          } else if (this.CurrentUser.item.language == 'en_uk') {
            this.Patpro.code = '+44,UK'
            this.Patpro.codeOther = '+44,UK'
          }
          if (this.CurrentUser.item.clientTeleCode) {
            this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
            this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
          }
          this.setnumber(this.Patpro.code)
          this.setnumber1(this.Patpro.codeOther)

          if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
          if (this.CurrentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
          this.getPreferredLanguage();
        }
      }
    )
    this.hospitalid = this.CurrentUser.item.userAccountKey;
    ////console.log("id",this.hospitalid)
    if (this.route.snapshot.url[0].path != 'assessment') {
      this.CurrentUser.operationStatus = ''
    }
    //this.Patpro.gender="choose...";


    let self = this;
    self.patientservice.getselcode(this.hospitalid)
      .subscribe(data => {
        self.codes = data
        ////console.log("code",data)
      })
    self.patientservice.getAlterNo()
      .subscribe(data => {
        self.alterNo = data
        self.Patpro.otherPhoneType = 1

        ////console.log("code",data)
      })

    this.Patpro.otherPhoneType = 1
  }

  // addtermschange(){
  //     if(this.terms === )
  //     {
  //       this.terms = "true";
  //     }
  //     else
  //     {
  //       this.terms = 0;
  //     }
  //     //////console.log("terms" + this.terms);
  // }

  // addcareimgurl(event) {
  //   this.defaultimg=false;
  //   //////console.log("hidde" + this.defaultimg);
  //   let reader = new FileReader();
  //   reader.readAsDataURL(event.target.files[0]);
  //   reader.onload = (events: any) => {
  //     this.caredataimg = events.currentTarget.result; // base64
  //     //////console.log(event.target.files[0]);
  //     this.careimagearr = [{
  //       filename: event.target.files[0].name,
  //       filetype: event.target.files[0].type,
  //       value: events.currentTarget.result.split(',')[1]
  //     }];
  //     //////console.log(this.careimagearr);
  //   }
  // }
  email_val: any;
  onSelection(event, userdetails) {

    this.email_val = event ? event.target.value : this.Patpro.email;
    var special = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (this.email_val && this.email_val.match(special)) {
      let self = this;
      let data = {
        "oldEmail": '',
        "newEmail": this.email_val,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": "add",
        "updatingProfileRole": 20
      }
      this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
        data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.userservice.getuserdetails(this.email_val)
                .subscribe(
                  (data) => {
                    if (data.firstName) {
                      self.getEmaildata = data
                      if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || (data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName))) {
                        if (!this.modalRef1 || !this.modalRef1.content)
                          this.modalRef1 = this.modalService.show(userdetails, {
                            class: 'modal-md',
                            backdrop: 'static'
                          })

                        //this.movable();
                      }
                      //this.selection()
                    }

                  });
              return false
            }
          } else {
            self.Patpro.email = ""
            if (!this.alertShowed) {
              self.toast.error(this.userservice.translateText('patient_portal.validations.email_already_exist.error_label'), '', {
                timeOut: this.timealert
              })
              this.alertShowed = true;
            }
            this.checkEmailClear = false
            return false;
          }
        });
    }
    else {
      return true
    }

  }
  onSelection1(event, userdetails) {
    let telecode: any;
    telecode = this.Patpro.code.split(',')
    this.mobile_val = telecode[0] + '-' + this.Patpro.phone;
    if (this.Patpro.phone) {
      let self = this;
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": '',
        "newPhone": telecode[0] + '-' + this.Patpro.phone,
        "addOrEdit": "add",
        "updatingProfileRole": 20
      }
      this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
        data => {
          if (data.status == 'success') {
            if (data.popUpStatus == 'true') {
              this.userservice.getuserdetails(this.mobile_val)
                .subscribe(
                  data => {
                    if (data.firstName) {
                      self.getEmaildata = data
                      if (((!this.Patpro.firstName && !this.Patpro.lastName && !this.Patpro.email) || (data.firstName != this.Patpro.firstName) || (data.lastName != this.Patpro.lastName) || (data.email != this.Patpro.email))) {
                        if (!this.modalRef1 || !this.modalRef1.content) {
                          this.modalRef1 = this.modalService.show(userdetails, {
                            class: 'modal-md',
                            backdrop: 'static'
                          });
                        }
                        // this.movable();
                      }
                    }
                    ////console.log("getEmaildata", data)
                  });
              return false;
            }
          } else if (this.Patpro.phone) {
            this.Patpro.phone = '';
            if (!this.alertShowed) {
              this.toast.error(this.userservice.translateText('patient_portal.validations.mobile_no_already_exist.error_label'), '', {
                timeOut: this.timealert
              })
              this.alertShowed = true;
            }
            this.checkPhoneClear = false
            return false;

          }
        });

    }

    else {
      return true;
    }

  }
  tempCode: any;
  duplicateshow: any;
  modalRef1: BsModalRef;
  selection(status) {
    this.modalRef1.hide()
    this.modalRef1 = undefined;
    if (this.getEmaildata && status) {
      this.duplicateshow = true;
      this.modalRef1 = new BsModalRef;
      this.Patpro.firstName = this.getEmaildata.firstName;
      this.Patpro.phone = this.getEmaildata.phone;
      this.Patpro.phoneOther = this.getEmaildata.phoneOther;
      this.Patpro.otherPhoneType = this.getEmaildata.otherPhoneType ? this.getEmaildata.otherPhoneType : 1;
      this.Patpro.lastName = this.getEmaildata.lastName;
      this.Patpro.gender = this.getEmaildata.gender;
      this.Patpro.email = this.getEmaildata.email ? this.getEmaildata.email : '';
      this.Patpro.relationship = this.Patpro.relationship ? this.Patpro.relationship : ''
      this.Patpro.code = this.getEmaildata.teleCode + ',' + this.getEmaildata.teleCountryCode;
      this.Patpro.codeOther = this.getEmaildata.teleCodeOther + ',' + this.getEmaildata.teleCountryCodeOther;
      this.defaultimg = false;
      this.defaultmyimg = true;
      this.caredataimg = this.imageURL + this.getEmaildata.imagePath;
      if (this.Patpro.phone) {
        this.setnumb(this.Patpro.code)
      }
      if (this.Patpro.phoneOther) {
        this.setnumb(this.Patpro.codeOther)
      }
      if (!this.getEmaildata.teleCode) {
        if (this.CurrentUser.item.language != 'en_uk') {
          this.Patpro.code = '+1,USA'
        } else if (this.CurrentUser.item.language == 'en_uk') {
          this.Patpro.code = '+44,UK'
        }
        if (this.CurrentUser.item.clientTeleCode)
          this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode

      }
      if (!this.getEmaildata.teleCodeOther) {
        if (this.CurrentUser.item.language != 'en_uk') {
          this.Patpro.codeOther = '+1,USA'
        } else if (this.CurrentUser.item.language == 'en_uk') {
          this.Patpro.codeOther = '+44,UK'
        }
        if (this.CurrentUser.item.clientTeleCode)
          this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode

      }
      this.tempCode = this.patientdetail.code
    } else {
      this.Patpro.email = ''
      this.Patpro.phone = ''
      this.checkEmailClear = false
      this.checkPhoneClear = false
      this.Patpro.code = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
    }


  }
  addcareimgurl(event) {
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (events: any) => {
      if (!acceptFormat.includes(event.target.files[0].type)) {
        this.toast.error(this.userservice.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
          timeOut: this.timealert
        })
        // this.myInputVariable.nativeElement.value = "";
        this.defaultimg = true;
        this.defaultmyimg = false;
        this.caredataimg = this.defaultimg;
        return;
      }
      if (event.target.files[0].size > this.imgMaxSize) {
        this.toast.error(this.userservice.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
          timeOut: this.timealert
        })
        // this.myInputVariable.nativeElement.value = "";
        this.defaultimg = true;
        this.defaultmyimg = false;
        this.caredataimg = this.defaultimg;
        return;
      } else {
        this.defaultimg = false;
        this.defaultmyimg = true;
        //////console.log("hidde" + this.defaultimg);
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (events: any) => {
          this.caredataimg = events.currentTarget.result; // base64
          //////console.log(event.target.files[0]);
          this.careimagearr = [{
            filename: event.target.files[0].name,
            filetype: event.target.files[0].type,
            value: events.currentTarget.result.split(',')[1]
          }];
          //////console.log(this.careimagearr);
        }



      }

    }
  }






  btndisable: boolean
  addcarepostfun(car, sucessda) {
    this.btndisable = true
    if (this.checkPhoneClear && !this.duplicateshow)
      this.phonechange(car, sucessda)
    else if (this.checkEmailClear && !this.duplicateshow)
      this.emailchange(this.Patpro.email, car, sucessda)
    else
      this.savedetails(car, sucessda)

  }
  phonechange(car, sucessda) {
    let telecode: any;
    telecode = this.Patpro.code.split(',')
    this.mobile_val = telecode[0] + '-' + this.Patpro.phone;
    if (this.Patpro.phone) {
      let data = {
        "oldEmail": '',
        "newEmail": '',
        "oldPhone": '',
        "newPhone": telecode[0] + '-' + this.Patpro.phone,
        "addOrEdit": "add",
        "updatingProfileRole": 20
      }
      this.userExists(data, car, sucessda)
    }
  }
  emailchange(event, car, sucessda) {
    this.email_val = event ? event : this.Patpro.email;
    var special = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g;
    if (this.email_val && this.email_val.match(special)) {
      let data = {
        "oldEmail": '',
        "newEmail": this.email_val,
        "oldPhone": '',
        "newPhone": '',
        "addOrEdit": "add",
        "updatingProfileRole": 20
      }
      this.userExists(data, car, sucessda)
    }
  }
  userExists(data, car, sucessda) {
    this.patientservice.getUserExist(data, this.CurrentUser.item.userAccountKey).subscribe(
      data => {
        if ((data.popUpStatus == 'true' && data.status == 'success') || data.message == 'User already Exist') {
          this.btndisable = false
          return;
        }
        else {
          this.savedetails(car, sucessda)
        }
      })
  }
  savedetails(car, sucessda) {

    if ((car.value.phone.length < this.setlength && car.value.phone != '')) {
      this.btndisable = true
      return
    }

    this.showloader = true;
    this.btnshow = false;
    this.btnshow1 = true;
    this.btndisable = false
    car.value.uploadimage = this.careimagearr;
    if (this.careimagearr == undefined) {
      car.value.uploadimage = [{}];
    }




    if (car.value.phone == undefined || car.value.phone == '') {
      car.value.phone = ""
      car.value.teleCode = ""
      car.value.teleCountryCode = ""
    }
    else {
      let telecode = car.value.code.split(',')
      car.value.teleCode = telecode[0]
      car.value.teleCountryCode = telecode[1]
    }
    if (car.value.phoneOther == undefined || car.value.phoneOther == '') {
      car.value.phoneOther = ""
      car.value.teleCodeOther = ""
      car.value.teleCountryCodeOther = ""
    }
    else {
      let telecode = car.value.code.split(',')
      car.value.teleCodeOther = telecode[0]
      car.value.teleCountryCodeOther = telecode[1]
    }
    if (!car.value.otherPhoneType)
      car.value.otherPhoneType = ''
    //////console.log(car.value);
    this.userservice
      .addcarefamily(car.value)
      .subscribe(
        data => {

          this.showloader = false;
          //////console.log(data);

          //     if (data.message =="Email address already exists") {
          //       this.ffar = "Email address already exists";
          //       this.btnshow= true;
          //     this.btnshow1=false;
          //  //this.resdata = "Email Id already exists";
          //   //this.modalRef = this.modalService.show(sucessda, {class: 'modal-sm'});

          //   }
          //  else
          if (data.message) {
            this.ffar = "";
            this.resdata = data.message;

            this.modalRef = this.modalService.show(sucessda, { class: 'modal-sm', backdrop: 'static' });
            this.movable()
            this.btnshow = true;
            this.btnshow1 = false;
            this.userservice.logAudit("addcarepartner", 0).subscribe(data => { })
          }
          //  else {
          //   this.ffar = "Enter all fields";
          // }
        }
      );
  }


  // addcaregender = ['Male', 'Female'];
  relationships = [
    this.userservice.translateText('patient_portal.care_partner.spouse.label'),
    this.userservice.translateText('patient_portal.care_partner.child.label'),
    this.userservice.translateText('patient_portal.care_partner.parent.label'), 
    this.userservice.translateText('patient_portal.care_partner.other_family.label'),
    this.userservice.translateText('patient_portal.care_partner.non_family.label'), 
    this.userservice.translateText('patient_portal.care_partner.friend.label'), 
    this.userservice.translateText('patient_portal.care_partner.professional_caregiver.label'), 
    this.userservice.translateText('patient_portal.care_partner.Unknown.label')];

  setnumber(e) {
    this.Patpro.phone = "";
    let telecode = e.split(',')
    ////console.log(telecode)
    let codecoun = telecode[1]
    this.userservice.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength = data.Length;
          this.maxlen = data.Length + this.CurrentUser.item.length;
          ////console.log(this.maxlen)
          ////console.log("this.setlength",this.setlength)
        }
      );

  }
  setnumber1(e) {
    this.Patpro.phoneOther = "";
    let telecode = e.split(',')
    ////console.log(telecode)
    let codecoun = telecode[1]
    this.userservice.phonebycountrycode(codecoun)
      .subscribe(
        data => {
          this.setlength1 = data.Length;
          this.maxlen1 = data.Length + this.CurrentUser.item.length;
          ////console.log(this.maxlen)
          ////console.log("this.setlength",this.setlength)
        }
      );

  }
  setnumb(e) {
    let code = this.Patpro.code.split(',')
    let codeOther
    codeOther = this.Patpro.codeOther.split(',')
    if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phoneOther) {
      this.toast.error(this.userservice.translateText('patient_portal.display_messages.mobile_no_alter_no_should_not_same'), '', {
        timeOut: this.timealert
      })
      return this.Patpro.phone = ''
    } else {
      let telecode = e.split(',')
      ////console.log(telecode)
      let codecoun = telecode[1]
      this.userservice.phonebycountrycode(codecoun)
        .subscribe(
          data => {
            this.setlength = data.Length;
            this.maxlen = data.Length + this.CurrentUser.item.length;
            if (data.Length == 11) {
              this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
            } else {
              this.setmask = this.CurrentUser.item.phoneFormat.split('#').join('0')
            }
            ////console.log(this.maxlen)
            ////console.log("this.setlength",this.setlength)
          }
        );
    }

  }
  setnumb1(e) {
    let code
    code = this.Patpro.code.split(',')
    let codeOther = this.Patpro.codeOther.split(',')
    if (code[0] + this.Patpro.phone == codeOther[0] + this.Patpro.phoneOther && this.Patpro.phone) {
      this.toast.error(this.userservice.translateText('patient_portal.display_messages.mobile_no_alter_no_should_not_same'), '', {
        timeOut: this.timealert
      })
      return this.Patpro.phoneOther = ''
    } else {
      let telecode = e.split(',')
      ////console.log(telecode)
      let codecoun = telecode[1]
      this.userservice.phonebycountrycode(codecoun)
        .subscribe(
          data => {
            this.setlength1 = data.Length;
            this.maxlen1 = data.Length + this.CurrentUser.item.length;
            if (data.Length == 11) {
              this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0').concat('0')
            } else {
              this.setmask1 = this.CurrentUser.item.phoneFormat.split('#').join('0')
            }
            ////console.log(this.maxlen)
            ////console.log("this.setlength",this.setlength)
          }
        );
    }

  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }

  //alternative no
  phoneOthervalue: any = false
  viewalterno(phoneOthervalue) {
    if (!phoneOthervalue) {
      this.phoneOthervalue = true
      this.Patpro.otherPhoneType = 1
      this.changeAlterNo()
    }
  }
  changeAlterNo() {
    if (this.CurrentUser.item.language != 'en_uk') {
      this.Patpro.codeOther = '+1,USA'
    } else if (this.CurrentUser.item.language == 'en_uk') {
      this.Patpro.codeOther = '+44,UK'
    }
    if (this.CurrentUser.item.clientTeleCode) {
      this.Patpro.codeOther = this.CurrentUser.item.clientTeleCode + ',' + this.CurrentUser.item.clientCountryCode
    }
    this.Patpro.phoneOther = ''
  }
  @ViewChild('ca') myForm: NgForm;
  // setEmailorPhoneValidation(valuechange,event){
  //   console.log("event",event);
  //   if(event && !this.Patpro.email && !this.Patpro.phone){
  //     this.myForm.form.get('email').setValidators([Validators.required]);
  //     this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
  //     this.myForm.form.get('email').updateValueAndValidity();

  //     this.myForm.form.get('phone').setValidators([Validators.required]);
  //     this.myForm.form.get('phone').setValidators([Validators.minLength(10)]);
  //     this.myForm.form.get('phone').updateValueAndValidity();
  //   }else if(valuechange && !event){
  //     this.myForm.form.get('email').clearValidators();
  //     this.myForm.form.get('email').updateValueAndValidity();
  //     this.myForm.form.get('phone').clearValidators();
  //     this.myForm.form.get('phone').updateValueAndValidity();
  //   }
  // }

  setEmailorPhoneValidation(event) {
    // console.log("event", event);
    if (event && !this.Patpro.email && !this.Patpro.phone) {
      this.myForm.form.get('email').setValidators([Validators.required]);
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();

      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else if (event && this.Patpro.email) {
      this.myForm.form.get('email').setValidators([Validators.required]);
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();
      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else if (event && this.Patpro.phone) {
      this.myForm.form.get('email').clearValidators();
      this.myForm.form.get('email').updateValueAndValidity();

      this.myForm.form.get('phone').setValidators([Validators.required]);
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
    else {
      this.myForm.form.get('email').clearValidators();
      this.myForm.form.get('email').setValidators([Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]);
      this.myForm.form.get('email').updateValueAndValidity();
      this.myForm.form.get('phone').clearValidators();
      this.myForm.form.get('phone').setValidators([Validators.minLength(this.setlength), Validators.maxLength(this.maxlen)]);
      this.myForm.form.get('phone').updateValueAndValidity();
    }
  }
  activate(template) {
    if (this.Patpro.onBehalf && !this.Patpro.email && !this.Patpro.phone) {
      this.modalRef1 = this.modalService.show(template, {
        class: 'modal-sm',
        backdrop: 'static'
      })
      this.movable();
    }
  }
  validateEmail(email) {

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());

  }
  validatemail: any = false
  required: any = false
  checkEmail() {
    let self = this;
    let checkEmail = self.validateEmail(self.Patpro.email.toLowerCase())
    if (checkEmail || self.Patpro.email == '') {
      self.validatemail = false
    } else if (!checkEmail && self.Patpro.email) {
      self.required = true;
      self.validatemail = true
      self.toast.error(this.userservice.translateText('patient_portal.validations.enter_a_valid_email.error_label'), '', {
        timeOut: this.timealert
      })

    }
  }


  checkPhoneClear: boolean;
  setPhoneValue: any;
  backupPhoneValue(event) {
    if (event) {
      this.checkPhoneClear = true;
      this.setPhoneValue = event;
      this.duplicateshow = false
    }
    else {
      this.checkPhoneClear = false;
    }

    // console.log("setPhoneValue",this.checkPhoneClear)
  }

  checkEmailClear: boolean;
  setEmailValue: any;
  backupEmailValue(event) {
    if (event) {
      this.checkEmailClear = true;
      this.setEmailValue = event;
      this.duplicateshow = false
      if (event.length < this.setlength)
        this.btndisable = true
      else
        this.btndisable = false
    }
    else {
      this.checkEmailClear = false;
      this.btndisable = false
    }
    // console.log("setEmailValue",this.checkEmailClear)
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }

  getPreferredLanguage() {
		let targetEmail;
		if (this.CurrentUser && this.CurrentUser?.item?.email) {
			targetEmail = this.CurrentUser?.item?.email
		} 
    
		const credential = {
		  'userName': !targetEmail && !this.CurrentUser?.item?.phone ? null : !targetEmail ? this.CurrentUser?.item?.clientTeleCode.replace("+",'') + "-" + this.CurrentUser?.item?.phone : targetEmail 
		}

    if(!this.CurrentUser?.item?.email && !this.Patpro.phone)
			credential['clientId'] = this.CurrentUser?.item?.userAccountKey || '';

		this.languageSubscription = this.userservice.getLanguageConfig(credential).subscribe(
		  langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          this.languageConfig = langConfigRes;
        }
		});
	}
}






